import { SelectionModel } from "@angular/cdk/collections";
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    OnDestroy,
    SystemJsNgModuleLoader,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { fuseAnimations } from "@fuse/animations";
import { OrdenTrabajoDTO } from "app/main/apps/shared/interfaces/orden-trabajo.interface";
import { PageOrdenTrabajoDTO } from "app/main/apps/shared/interfaces/page-orden-de-trabajo.interface";
import { Subject, merge, of, Subscription } from "rxjs";
import {
    takeUntil,
    switchMap,
    map,
    catchError,
    tap,
    filter,
} from "rxjs/operators";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { OrdenesDeTrabajoService } from "app/main/apps/shared/services/rest/ordenes-de-trabajo.service";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";
import { config } from "app/app.config";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { NotificacionesService } from "app/main/apps/shared/services/rest/notificaciones.service";
import { HelpersService } from "app/main/apps/shared/services/util/helpers.service";

@Component({
    selector: "app-listado-oott",
    templateUrl: "./listado-oott.component.html",
    styleUrls: ["./listado-oott.component.scss"],
    animations: fuseAnimations,
})
export class ListadoOOTTComponent implements OnInit, OnDestroy {
    @Input() ootts: OrdenTrabajoDTO[];
    @Input() total: number;
    @Output()
    editarNroTicketEvent: EventEmitter<OrdenTrabajoDTO> = new EventEmitter();

    @Output() buscarMas: EventEmitter<any> = new EventEmitter();
    @Output() asignarOOCC: EventEmitter<any> = new EventEmitter();
    dataSource: MatTableDataSource<OrdenTrabajoDTO>;
    displayedColumns = [
        "select",
        "idOrdenTrabajo",
        "cliente",
        "estado",
        "pagoContratista",
        "rut",
        "s.nombre",
        "numeroticket",
        "fecha",
        "valor",
        "ordenCompra",
    ];

    @ViewChild(MatPaginator, { static: true })
    paginator: MatPaginator;

    @ViewChild(MatSort, { static: true })
    sort: MatSort;

    selection = new SelectionModel<any>(true, []);
    resultsLength = 0;
    private subscripciones: Subscription;
    private _unsubscribeAll: Subject<any>;
    config;
    oottMismoCliente: boolean;

    constructor(
        private _fuseProgressBarService: FuseProgressBarService,
        private _oottSrvc: OrdenesDeTrabajoService,
        public _menuUsuarioSrvc: MenuUsuarioService,
        private _helpersSrvc: HelpersService,
        private _notificacionSrvc: NotificacionesService
    ) {
        this.oottMismoCliente = true;
        this.config = config;
        this.subscripciones = new Subscription();
        this._unsubscribeAll = new Subject();
    }

    ngAfterViewInit(): void {
        //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
        //Add 'implements AfterViewInit' to the class.
    }

    ngOnInit(): void {
        this.dataSource = new MatTableDataSource(this.ootts);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.subscripciones.add(
            this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0))
        );
        setTimeout(() => {
            this.tableChange();
        });
    }

    tableChange() {
        this.resultsLength = this.total;
        this.subscripciones.add(
            merge(
                this.sort.sortChange,
                this.paginator.page,
                this._oottSrvc.oottsRefresh$.pipe(
                    //tap((data) => console.log("refresh!", data)),
                    filter(
                        (refresh) => refresh //filtro para contratistasRefresh$, merge se activa solo si el valor emitido es true, para evitar dobles llamadas
                    )
                )
            )
                .pipe(
                    // startWith({}),
                    takeUntil(this._unsubscribeAll),
                    switchMap(() => {
                        this._fuseProgressBarService.show();
                        this._oottSrvc.setPaginaActual(
                            this.paginator.pageIndex
                        );
                        this._oottSrvc.setCantidaResultadosPorPagina(
                            this.paginator.pageSize
                        );

                        this._oottSrvc.setCampoOrden(this.sort.active);
                        this._oottSrvc.setOrden(this.sort.direction);

                        this.buscarMas.emit();

                        //return this.buscar();
                        return this._oottSrvc.oottsChanged$;
                    }),
                    map((data: PageOrdenTrabajoDTO) => {
                        // Flip flag to show that loading has finished.

                        this._fuseProgressBarService.hide();

                        this.resultsLength = data.totalElements;

                        return data.content;
                    }),
                    catchError(() => {
                        this._fuseProgressBarService.hide();
                        // Catch if the GitHub API has reached its rate limit. Return empty data.

                        return of([]);
                    })
                )
                .subscribe((data: OrdenTrabajoDTO[]) => {
                    this.ootts = data;
                    this.dataSource = new MatTableDataSource(this.ootts);
                })
        );
    }

    editarNroTicket(oott: OrdenTrabajoDTO) {
        this.editarNroTicketEvent.emit(oott);
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        this.isAllSelected()
            ? this.selection.clear()
            : this.dataSource.data.forEach((row) => this.selection.select(row)); //this.dataSource.data.forEach((row) => this.selection.select(row));
    }

    /** The label for the checkbox on the passed row */
    checkboxLabel(row?: any): string {
        if (!row) {
            return `${this.isAllSelected() ? "select" : "deselect"} all`;
        }
        return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${
            row.position + 1
        }`;
    }

    asociarOOCC(oott?: OrdenTrabajoDTO) {
        const oottSeleccionadas = oott || this.selection.selected;
        this.asignarOOCC.emit(oottSeleccionadas);
    }
    ngOnDestroy(): void {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subscripciones.unsubscribe();
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    toggleSelect(event: MatCheckboxChange, oott: OrdenTrabajoDTO) {
        event ? this.selection.toggle(oott) : null;
        if (this.selection.selected.length >= 1) {
            this.oottMismoCliente = this._helpersSrvc.verificaChecboxMismoPadre(
                this.selection,
                oott.sucursal.cliente.id, //cambiar a idCliente cunado se agregue este campo en el DTO
                "sucursal.cliente.id", //cambiar a idCliente cunado se agregue este campo en el DTO
                event.checked
            ); //cambiar a idCliente cunado se agregue este campo en el DTO

            if (!this.oottMismoCliente) {
                this._notificacionSrvc.mostrarNotificacion(
                    "Todas las OOTT seleccionadas deben pertenecer al mismo cliente",
                    "info"
                );
            }
        }
    }
}
